'use client';

import React from 'react';
import { AISearchBarMobile } from '@/features/ai-search/AISearchBarMobile';
import { useAiSearchStatus } from '@/features/ai-search/hooks/useAiSearchStatus';
import { ListingsSearchBarMobile } from '@/features/listings/ListingsSearchBar.Mobile';

/**
 * Mobile-web home search (rent tab): the AI search bar ONLY when
 * `/ai-search/status/` says `enabled`. In every other case — still loading,
 * disabled, or the status call failed — it shows the legacy mobile listings
 * search that's there today. Reviews-tab search is handled separately in
 * `TopBarMobile`.
 */
export interface HomeSearchMobileProps {
  /** Controlled open state for the AI full-page overlay (opened from the header mini bar). */
  open?: boolean | undefined;
  onOpenChange?: ((open: boolean) => void) | undefined;
}

export function HomeSearchMobile({ open, onOpenChange }: HomeSearchMobileProps = {}) {
  const status = useAiSearchStatus();

  // Render the AI bar by default (including while loading) to avoid a flash of the
  // legacy bar; only show legacy when the switch is explicitly `disabled`.
  if (status !== 'disabled') return <AISearchBarMobile open={open} onOpenChange={onOpenChange} />;

  return <ListingsSearchBarMobile />;
}

export default HomeSearchMobile;
